module.exports = __webpack_public_path__ + "img/check.2b2d1d1e.svg";